import React, { PropsWithChildren, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ResultContainer, ResultText } from 'components';
import {
  ExistingUserContainer,
  ExistingUserText,
  EmailButton,
  SuggestionContainer,
  SuggestionText,
  ChallengeCardContainer,
  ChallengeSubtitle,
  NextChallengeTitle,
  Description,
} from '../quiz-result/components';
import { changeEmail } from '../quiz-result/actions';
import ParallaxSection from 'components/parallax-section';
import { QUIZ_RESULT_SECTION_ID } from 'modules/quiz-result';
import UnitedQuizTrial from 'modules/unite-quiz-trial';

type UniteQuizResultProps = {
  quizResultSectionRef: React.MutableRefObject<HTMLDivElement | null>;
  resultText: string;
  suggestion: string;
  challengeImage: string;
  challengeTitle: string;
  challengeSubtitle: string;
  description: string;
  existingUserText: string;
  goToAppButtonText: string;
  changeEmailButtonText: string;
  email?: string;
};

const UniteQuizResult = ({
  quizResultSectionRef,
  resultText,
  suggestion,
  challengeImage,
  challengeTitle,
  challengeSubtitle,
  description,
  existingUserText,
  goToAppButtonText,
  changeEmailButtonText,
  email,
  children,
}: PropsWithChildren<UniteQuizResultProps>) => {
  const dispatch = useDispatch();
  const onChangeEmail = useCallback(() => {
    dispatch(changeEmail());
  }, [dispatch]);

  return (
    <>
      {children}
      <ParallaxSection topPadding="25rem">
        <ResultContainer ref={quizResultSectionRef} id={QUIZ_RESULT_SECTION_ID}>
          <ResultText>{resultText}</ResultText>
          <SuggestionContainer>
            <SuggestionText>{suggestion}</SuggestionText>
            <ChallengeCardContainer imageUrl={challengeImage}>
              <div>
                <ChallengeSubtitle>{challengeSubtitle}</ChallengeSubtitle>
              </div>
              <div>
                <NextChallengeTitle>{challengeTitle}</NextChallengeTitle>
              </div>
            </ChallengeCardContainer>
          </SuggestionContainer>
          <Description>{description}</Description>
          {!email && <UnitedQuizTrial />}
          {email && (
            <ExistingUserContainer>
              <ExistingUserText>{existingUserText}</ExistingUserText>
              <EmailButton
                onClick={() => {
                  window.location.href = process.env.REACT_APP_APP_URL!;
                }}>
                {goToAppButtonText}
              </EmailButton>
              <EmailButton onClick={onChangeEmail}>
                {changeEmailButtonText}
              </EmailButton>
            </ExistingUserContainer>
          )}
        </ResultContainer>
      </ParallaxSection>
    </>
  );
};

export default UniteQuizResult;
